module.exports = __webpack_public_path__ + "static/media/wait_time_background.fb7beebb.jpg";